/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Th3Inputs */

const en_mk_cmp_clickup_th3 = /** @type {(inputs: Mk_Cmp_Clickup_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rich automation, but a per-action agent approval gate we did not find.`)
};

const id_mk_cmp_clickup_th3 = /** @type {(inputs: Mk_Cmp_Clickup_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomasi kaya, tapi gerbang approval per aksi agen tidak kami temukan.`)
};

/**
* | output |
* | --- |
* | "Rich automation, but a per-action agent approval gate we did not find." |
*
* @param {Mk_Cmp_Clickup_Th3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_th3 = /** @type {((inputs?: Mk_Cmp_Clickup_Th3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Th3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_th3(inputs)
	return en_mk_cmp_clickup_th3(inputs)
});